import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { TLS } from '../../components/TLC'; 

const TLSPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>ТЛС</title>
            </Helmet>
            <TLS/>

        </>
    );
};

export default TLSPage
